import React, { useState, useRef, useEffect, useCallback, useMemo, createRef, } from "react";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { Snackbar } from "../snackbar/Snackbar";
import "./FlashOverlay.scss";
export const FlashContext = React.createContext({});
const DEFAULT_TIMER = 5000;
export const FlashOverlay = ({ children }) => {
    const [flashes, setFlashes] = useState([]);
    const flashRef = useRef(flashes);
    const animationRefs = useRef([]);
    useEffect(() => {
        flashRef.current = flashes;
    }, [flashes]);
    const addFlash = useCallback((flash) => {
        const id = Math.random().toString(36).slice(2, 11);
        setFlashes([...flashRef.current, Object.assign(Object.assign({}, flash), { id })]);
        setTimeout(() => {
            const newFlashes = [...flashRef.current];
            const idx = newFlashes.findIndex((item) => item === flash);
            if (typeof idx === "undefined") {
                return;
            }
            newFlashes.splice(idx, 1);
            setFlashes(newFlashes);
        }, flash.timer || DEFAULT_TIMER);
        return id;
    }, [setFlashes]);
    const removeFlash = useCallback((flashId) => {
        if (flashId === undefined) {
            return;
        }
        const newFlashes = [...flashRef.current];
        const flashIndex = newFlashes.findIndex((item) => item.id === flashId);
        if (flashIndex === undefined) {
            return;
        }
        newFlashes.splice(flashIndex, 1);
        setFlashes(newFlashes);
    }, [setFlashes]);
    const contextValue = useMemo(() => ({
        pushFlash: addFlash,
        dropFlash: removeFlash,
    }), [addFlash, removeFlash]);
    animationRefs.current = flashes.map((_, i) => { var _a; return (_a = animationRefs.current[i]) !== null && _a !== void 0 ? _a : createRef(); });
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "lysa-ui-flash" },
            React.createElement(TransitionGroup, null, flashes.map((flash, i) => (React.createElement(CSSTransition, { key: flash.id, timeout: 600, className: "lysa-ui-flash-animation", unmountOnExit: true, mountOnEnter: true, nodeRef: animationRefs.current[i] },
                React.createElement("div", { ref: animationRefs.current[i] },
                    React.createElement(Snackbar, { key: flash.id, type: flash.type }, flash.text))))))),
        React.createElement(FlashContext.Provider, { value: contextValue }, children)));
};
export function useFlashContext() {
    const flashContext = React.useContext(FlashContext);
    if (typeof flashContext.pushFlash === "undefined") {
        throw new Error("useFlashContext must be used within a FlashOverlay");
    }
    return flashContext;
}
export const withFlashContext = (Component) => (props) => (React.createElement(FlashContext.Consumer, null, (contextProps) => React.createElement(Component, Object.assign({}, props, contextProps))));
